import { render } from "./confirmationModal.vue?vue&type=template&id=fec937a6&scoped=true&ts=true"
import script from "./confirmationModal.vue?vue&type=script&lang=ts"
export * from "./confirmationModal.vue?vue&type=script&lang=ts"

import "./confirmationModal.vue?vue&type=style&index=0&id=fec937a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fec937a6"]])

export default __exports__